const SERIAL_CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
const API_KEY_CHARS =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*-_=+";

function randomBytes(len: number): Uint8Array {
  const buf = new Uint8Array(len);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(buf);
    return buf;
  }
  for (let i = 0; i < len; i += 1) {
    buf[i] = Math.floor(Math.random() * 256);
  }
  return buf;
}

/** Hardware-style serial e.g. `DL-A1B2C3`. */
export function generateSerialNumber(): string {
  const bytes = randomBytes(6);
  let out = "";
  for (let i = 0; i < 6; i += 1) {
    out += SERIAL_CHARS[bytes[i]! % SERIAL_CHARS.length];
  }
  return `DL-${out}`;
}

/** Long key: alphanumeric + symbols, minimum 32 characters. */
export function generateApiKey(byteLength = 32): string {
  const bytes = randomBytes(byteLength);
  let out = "";
  for (let i = 0; i < byteLength; i += 1) {
    out += API_KEY_CHARS[bytes[i]! % API_KEY_CHARS.length];
  }
  return out;
}

export function generateUUID(): string {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  const b = randomBytes(16);
  b[6] = (b[6]! & 0x0f) | 0x40;
  b[8] = (b[8]! & 0x3f) | 0x80;
  const hex = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
